module.exports = __webpack_public_path__ + "static/media/molar-with-cavity.f025122a.svg";